import { HttpClient } from "@angular/common/http";
import { Observable, Subscriber } from "rxjs";
import { tap } from "rxjs/operators";

export abstract class EventService<T> {
  private subscribers: Subscriber<T>[] = [];

  constructor(
    refreshWithTimer: boolean
  ) {
    if (refreshWithTimer) {
      this.scheduleRefresh();
    }
  }

  public disposeEventsSubscription(subscriber: Subscriber<T>) {
    const index = this.subscribers.indexOf(subscriber);
    if (index > -1) {
      this.subscribers.splice(index, 1);
    }
  }

  public getEvents(subscriber: Subscriber<T>) {
    this.subscribers.push(subscriber);
  }

  protected notify(event: T) {
    for (const subscriber of this.subscribers) {
      subscriber.next(event);
    }
  }

  abstract refresh(): Observable<T>;

  private refreshWithTimer() {
    this.refresh()
      .pipe(tap(event => this.notify(event)))
      .pipe(tap(_ => this.scheduleRefresh()))
      .subscribe({
        error: _ => this.scheduleRefresh()
      });
  }

  private scheduleRefresh() {
    setTimeout(() => this.refreshWithTimer(), 5000);
  }
}